(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sports-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-sports-hub]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const grid = root.querySelector('[data-events-grid]');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-sports-event]'));
      const empty = root.querySelector('[data-empty-state]');
      const count = root.querySelector('[data-visible-count]');
      let championship = 'all';
      let time = 'all';
      let favoritesOnly = false;
      let personalCalendarOnly = false;

      const personalRoot = root.querySelector('[data-personal-calendar]');
      const personalToggle = root.querySelector('[data-personal-toggle]');
      const personalExport = root.querySelector('[data-personal-export]');
      const personalSummary = root.querySelector('[data-personal-summary]');
      const personalNext = root.querySelector('[data-personal-next]');
      const recentRoot = root.querySelector('[data-recent-return]');
      const recentText = root.querySelector('[data-recent-return-text]');
      const recentLink = root.querySelector('[data-recent-return-link]');
      const recentResultsGrid = root.querySelector('[data-recent-results-grid]');
      const recentResultCards = recentResultsGrid ? Array.from(recentResultsGrid.querySelectorAll('[data-recent-result-card]')) : [];
      const recentResultsCount = root.querySelector('[data-recent-results-count]');
      const recentResultsEmpty = root.querySelector('[data-recent-results-empty]');
      const RECENT_KEY = 'op_sport_recent_v1';
      const opI18n = JSON.parse(root.querySelector('[data-sports-hub-i18n]').textContent);

      const recentState = () => {
        try {
          const raw = JSON.parse(localStorage.getItem(RECENT_KEY) || 'null');
          return raw && typeof raw === 'object' ? raw : null;
        } catch (_) {
          return null;
        }
      };

      const updateRecentReturn = () => {
        const recent = recentState();
        if (!recentRoot || !recentLink || !recentText) return;
        if (!recent || !recent.url || !recent.name) {
          recentRoot.hidden = true;
          return;
        }
        recentRoot.hidden = false;
        recentText.textContent = opI18n.lastSheet + ' ' + recent.name;
        recentLink.href = recent.url;
        recentLink.textContent = opI18n.backTo + ' ' + recent.name;
      };

      const updateRecentResults = () => {
        if (!recentResultsGrid) return;
        recentResultCards.sort((a, b) => new Date(b.dataset.resultEnd || 0) - new Date(a.dataset.resultEnd || 0));
        recentResultCards.forEach((card, index) => {
          card.hidden = index >= 3;
          recentResultsGrid.appendChild(card);
        });
        if (recentResultsCount) {
          recentResultsCount.textContent = recentResultCards.length
            ? recentResultCards.length + ' ' + opI18n.eventsWithResults
            : '';
        }
        if (recentResultsEmpty) recentResultsEmpty.hidden = recentResultCards.length > 0;
      };

      const favoriteState = () => (window.OPSportFavorites && window.OPSportFavorites.get())
        || { events: [], championships: [] };

      const isPersonalCard = (card) => {
        const state = favoriteState();
        return state.events.includes(card.dataset.eventId || '')
          || state.championships.includes(card.dataset.championship || '');
      };

      const personalCards = () => cards
        .filter(isPersonalCard)
        .sort((a, b) => new Date(a.dataset.start || 0) - new Date(b.dataset.start || 0));

      cards.sort((a, b) => new Date(a.dataset.start || 0) - new Date(b.dataset.start || 0));
      cards.forEach((card) => grid.appendChild(card));

      const sameDay = (a, b) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

      const isWeekendWindow = (date, now) => {
        const start = new Date(now);
        const day = start.getDay();
        const daysToSaturday = (6 - day + 7) % 7;
        start.setDate(start.getDate() + daysToSaturday);
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setDate(end.getDate() + 1);
        end.setHours(23, 59, 59, 999);
        return date >= start && date <= end;
      };

      const overlaps = (start, end, windowStart, windowEnd) => start <= windowEnd && end >= windowStart;
      const matchTime = (start, end) => {
        if (!start || Number.isNaN(start.getTime())) return false;
        const eventEnd = end && !Number.isNaN(end.getTime()) ? end : start;
        if (time === 'all') return true;
        const now = new Date();
        if (time === 'today') {
          const dayStart = new Date(now); dayStart.setHours(0,0,0,0);
          const dayEnd = new Date(now); dayEnd.setHours(23,59,59,999);
          return overlaps(start, eventEnd, dayStart, dayEnd);
        }
        if (time === 'weekend') {
          const weekendStart = new Date(now);
          const day = weekendStart.getDay();
          const daysToSaturday = (6 - day + 7) % 7;
          weekendStart.setDate(weekendStart.getDate() + daysToSaturday);
          weekendStart.setHours(0,0,0,0);
          const weekendEnd = new Date(weekendStart);
          weekendEnd.setDate(weekendEnd.getDate() + 1);
          weekendEnd.setHours(23,59,59,999);
          return overlaps(start, eventEnd, weekendStart, weekendEnd);
        }
        if (time === '7days') {
          const windowEnd = new Date(now);
          windowEnd.setDate(windowEnd.getDate() + 7);
          return overlaps(start, eventEnd, now, windowEnd);
        }
        if (time === 'month') {
          const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
          const monthEnd = new Date(now.getFullYear(), now.getMonth()+1, 0, 23,59,59,999);
          return overlaps(start, eventEnd, monthStart, monthEnd);
        }
        return true;
      };

      const apply = () => {
        let visible = 0;
        cards.forEach((card) => {
          const matchChampionship = championship === 'all' || card.dataset.championship === championship;
          const matchDate = matchTime(new Date(card.dataset.start || ''), new Date(card.dataset.end || card.dataset.start || ''));
          const favoriteEvents = favoriteState().events || [];
          const matchFavorite = !favoritesOnly || favoriteEvents.includes(card.dataset.eventId || '');
          const matchPersonal = !personalCalendarOnly || isPersonalCard(card);
          const show = matchChampionship && matchDate && matchFavorite && matchPersonal;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = String(visible);
        if (empty) empty.hidden = visible !== 0;

        const pcards = personalCards();
        if (personalExport) personalExport.disabled = pcards.length === 0;
        if (personalSummary) {
          personalSummary.textContent = pcards.length
            ? pcards.length + ' événement' + (pcards.length > 1 ? 's' : '') + ' dans votre calendrier personnalisé.'
            : opI18n.summary;
        }
        if (personalNext) {
          const upcoming = pcards.find((card) => new Date(card.dataset.end || card.dataset.start || 0) >= new Date());
          if (upcoming) {
            const date = new Date(upcoming.dataset.start || '');
            personalNext.hidden = false;
            personalNext.innerHTML = '<strong>' + opI18n.nextMeeting + '</strong> ' +
              (upcoming.dataset.eventName || '') + ' · ' +
              (Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-FR'));
          } else {
            personalNext.hidden = true;
            personalNext.textContent = '';
          }
        }
      };

      root.querySelectorAll('[data-filter-championship]').forEach((button) => {
        button.addEventListener('click', () => {
          championship = button.dataset.filterChampionship;
          root.querySelectorAll('[data-filter-championship]').forEach((item) => item.classList.toggle('is-active', item === button));
          apply();
        });
      });

      root.querySelectorAll('[data-filter-time]').forEach((button) => {
        button.addEventListener('click', () => {
          time = button.dataset.filterTime;
          root.querySelectorAll('[data-filter-time]').forEach((item) => item.classList.toggle('is-active', item === button));
          apply();
        });
      });

      const favoriteFilter = root.querySelector('[data-filter-favorites]');
      if (favoriteFilter) {
        favoriteFilter.addEventListener('click', () => {
          favoritesOnly = !favoritesOnly;
          favoriteFilter.classList.toggle('is-active', favoritesOnly);
          favoriteFilter.setAttribute('aria-pressed', favoritesOnly ? 'true' : 'false');
          apply();
        });
      }


      if (personalToggle) {
        personalToggle.addEventListener('click', () => {
          personalCalendarOnly = !personalCalendarOnly;
          personalToggle.classList.toggle('is-active', personalCalendarOnly);
          personalToggle.setAttribute('aria-pressed', personalCalendarOnly ? 'true' : 'false');
          personalToggle.textContent = personalCalendarOnly ? opI18n.viewAllEvents : opI18n.showCalendar;
          if (personalCalendarOnly) favoritesOnly = false;
          apply();
        });
      }

      if (personalExport) {
        personalExport.addEventListener('click', () => {
          const selected = personalCards();
          if (!selected.length) return;

          const escapeIcs = (value) => String(value || '')
            .replace(/\\/g, '\\\\')
            .replace(/\r?\n/g, '\\n')
            .replace(/,/g, '\\,')
            .replace(/;/g, '\\;');
          const toUtcIcs = (value) => {
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return '';
            return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
          };

          const reminderTrigger = (minutes) => {
            const value = Number(minutes) || 1440;
            if (value % 1440 === 0) return '-P' + (value / 1440) + 'D';
            if (value % 60 === 0) return '-PT' + (value / 60) + 'H';
            return '-PT' + value + 'M';
          };
          const CRLF = String.fromCharCode(13, 10);
          const now = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
          const lines = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Optimus Pneus//' + opI18n.myCalendar + '//',
            'CALSCALE:GREGORIAN',
            'METHOD:PUBLISH'
          ];

          const reminderState = window.OPSportReminders ? window.OPSportReminders.get() : { events: [], championships: [], leadMinutes: 1440 };

          selected.forEach((card) => {
            const start = toUtcIcs(card.dataset.start);
            const end = toUtcIcs(card.dataset.end || card.dataset.start);
            if (!start || !end) return;
            const absoluteUrl = new URL(card.dataset.eventUrl || '/', window.location.origin).href;
            const location = [card.dataset.eventVenue, card.dataset.eventCity, card.dataset.eventCountryName].filter(Boolean).join(', ');
            const uid = 'optimus-' + (card.dataset.eventId || card.dataset.eventName || '')
              .replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') + '@optimuspneus.fr';
            lines.push(
              'BEGIN:VEVENT',
              'UID:' + escapeIcs(uid),
              'DTSTAMP:' + now,
              'DTSTART:' + start,
              'DTEND:' + end,
              'SUMMARY:' + escapeIcs(card.dataset.eventName),
              'LOCATION:' + escapeIcs(location),
              'DESCRIPTION:' + escapeIcs([card.dataset.eventSummary || '', 'Fiche Optimus Pneus : ' + absoluteUrl].filter(Boolean).join('\\n\\n')),
              'URL:' + escapeIcs(absoluteUrl)
            );
            const reminderActive = reminderState.events.includes(card.dataset.eventId || '')
              || reminderState.championships.includes(card.dataset.championship || '');
            if (reminderActive) {
              lines.push(
                'BEGIN:VALARM',
                'TRIGGER;RELATED=START:' + reminderTrigger(reminderState.leadMinutes),
                'ACTION:DISPLAY',
                'DESCRIPTION:' + escapeIcs('Optimus Pneus — ' + (card.dataset.eventName || opI18n.eventDefault)),
                'END:VALARM'
              );
            }
            lines.push('END:VEVENT');
          });
          lines.push('END:VCALENDAR');

          const ics = lines.join(CRLF) + CRLF;
          const blob = new Blob([ics], { type: 'text/calendar' });
          const file = new File([blob], 'mon-calendrier-sportif-optimus-pneus.ics', { type: 'text/calendar' });
          const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

          const download = () => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'mon-calendrier-sportif-optimus-pneus.ics';
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
          };

          if (isMobile && navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
            navigator.share({ files: [file], title: opI18n.myCalendar + ' Optimus Pneus' })
              .catch((error) => { if (!error || error.name !== 'AbortError') download(); });
          } else {
            download();
          }

          const payload = {
            event: 'op_sport_personal_calendar_export',
            event_count: selected.length,
            page_path: window.location.pathname,
            timestamp: new Date().toISOString()
          };
          window.opSportTrackingQueue = window.opSportTrackingQueue || [];
          window.opSportTrackingQueue.push(payload);
          try { window.dispatchEvent(new CustomEvent('op_sport_personal_calendar_export', { detail: payload })); } catch (_) {}
          if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
        });
      }

      window.addEventListener('op:sport-favorites-changed', apply);

      const countdown = root.querySelector('[data-countdown]');
      if (countdown) {
        const target = new Date(countdown.dataset.countdown);
        const updateCountdown = () => {
          if (Number.isNaN(target.getTime())) {
            countdown.querySelectorAll('[data-days],[data-hours],[data-minutes],[data-seconds]').forEach((node) => { node.textContent = '00'; });
            return;
          }
          const delta = Math.max(0, target.getTime() - Date.now());
          const totalSeconds = Math.floor(delta / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const set = (selector, value) => {
            const node = countdown.querySelector(selector);
            if (node) node.textContent = String(value).padStart(2, '0');
          };
          set('[data-days]', days);
          set('[data-hours]', hours);
          set('[data-minutes]', minutes);
          set('[data-seconds]', seconds);
        };
        updateCountdown();
        window.setInterval(updateCountdown, 1000);
      }

      updateRecentReturn();
      updateRecentResults();
      apply();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
